import { useQuery } from "@tanstack/react-query"
import { useState } from "react"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import { useAuth } from "@/contexts/auth"
import { useReceivablesStore } from "@/stores"
import { StringHelper } from "@/utils"
export const getReceivables = async (
  params: ReceivablesSearchParamsType
) => {
  const newParams = {
    startDate: params.startDate,
    endDate: params.endDate,
    whitelabel_ids: params.whitelabel_ids,
  }
  const queryString =
    StringHelper.objectToQueryString(newParams)
  const url = `${ENDPOINTS.RECEIVABLE}?${queryString}`
  const { data } =
    await api.get<ReceivableMonthResponseType>(url)
  return data
}
const handleResponseData = (
  receivables: ReceivablesMonthType[]
) => {
  return receivables?.map((item: ReceivablesMonthType) => ({
    ...item,
    value: (item.value || 0) / 100,
    commissionValue: (item.commissionValue || 0) / 100,
    cashbackValue: (item.cashbackValue || 0) / 100,
    cashbackCommissionValue:
      (item.cashbackCommissionValue || 0) / 100,
    netValue: (item.netValue || 0) / 100,
    chargebackValue: (item.chargebackValue || 0) / 100,
  }))
}
const useReceivables = (
  params: ScheduleSearchingParamsType
) => {
  const [receivables, setReceivables] = useState<
    ReceivableMonthType[]
  >([])
  const setData = useReceivablesStore(
    (state) => state.setData
  )
  const { authData } = useAuth()
  const isAuthenticated = !!authData?.accessToken
  const { isFetching } = useQuery({
    queryKey: [ENDPOINTS.RECEIVABLE, params],
    queryFn: async () => {
      const response = await getReceivables(params)
      setData(handleResponseData(response?.receivables))
      setReceivables(
        handleResponseData(response?.receivables)
      )
      return response
    },
    enabled: isAuthenticated,
  })
  return {
    data: receivables,
    isFetching,
  }
}
export default useReceivables
